module.exports = __webpack_public_path__ + "static/media/Logo.faf25a01.png";